import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'round'
})
export class RoundPipe implements PipeTransform {

	transform(value: number, args: string = ""): any {
		switch (args.toLowerCase()) {
			case 'up':
				return Math.ceil(value);
			case 'down':
				return Math.floor(value);
			default:
				return Math.round(value);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/brightserve/pipes/round.pipe.ts